import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {memo} from 'react';
import {Button} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';


function NewProjectViewComponent() {

    let history = useHistory();

    return (

        <>
            <Button onClick={() =>
                history.push(process.env.REACT_APP_FRONTEND_PATH_PROJECTPAGE)

            }
                    className='handwai-btn-create'>
                <FontAwesomeIcon icon={faPlus}/>
                &emsp; Neues Projekt </Button>

        </>

    );


}

export default memo(NewProjectViewComponent);